import { AuthLogoutRequestAction } from "auth";
import { ClearCMSTokenAction } from "./ClearCMSToken";
import { CreateAppEndAction } from "./CreateApp";
import { CreateCMSTokenEndAction } from "./CreateCMSToken";
import { DeleteAppAction, DeleteAppEndAction } from "./DeleteApp";
import { DeleteCMSTokenAction, DeleteCMSTokenEndAction } from "./DeleteCMSToken";
import { ExportAppEndAction } from "./ExportApp";
import { ExportAppEraseAction } from "./ExportAppErase";
import { FetchAppAction, FetchAppEndAction } from "./FetchApp";
import { FetchCMSTokensAction, FetchCMSTokensEndAction } from "./FetchCMSTokens";
import { SearchAppsAction, SearchAppsEndAction } from "./SearchApps";

import { SubmitAppAction, SubmitAppEndAction } from "./SubmitApp";
import { UpdateAppEndAction } from "./UpdateApp";
import { UpdateTemplateAction, UpdateTemplateEndAction } from "./UpdateTemplate";
import { UploadBannerFailureAction, UploadBannerSuccessAction } from "./UploadBanner";
import { UploadIconFailureAction, UploadIconSuccessAction } from "./UploadIcon";
import { UploadTemplateAction, UploadTemplateEndAction } from "./UploadTemplate";

export * from "./ClearCMSToken";
export * from "./CreateApp";
export * from "./CreateCMSToken";
export * from "./DeleteApp";
export * from "./DeleteCMSToken";
export * from "./ExportApp";
export * from "./ExportAppErase";
export * from "./FetchApp";
export * from "./FetchCMSTokens";
export * from "./SearchApps";
export * from "./SubmitApp";
export * from "./UpdateApp";
export * from "./UpdateTemplate";
export * from "./UploadBanner";
export * from "./UploadIcon";
export * from "./UploadTemplate";

export type AppActions =
    | AuthLogoutRequestAction
    | ClearCMSTokenAction
    | CreateAppEndAction
    | CreateCMSTokenEndAction
    | DeleteAppAction
    | DeleteAppEndAction
    | DeleteCMSTokenAction
    | DeleteCMSTokenEndAction
    | ExportAppEndAction
    | ExportAppEraseAction
    | FetchAppAction
    | FetchAppEndAction
    | FetchCMSTokensAction
    | FetchCMSTokensEndAction
    | SearchAppsAction
    | SearchAppsEndAction
    | SubmitAppAction
    | SubmitAppEndAction
    | UpdateAppEndAction
    | UpdateTemplateAction
    | UpdateTemplateEndAction
    | UploadBannerSuccessAction
    | UploadBannerFailureAction
    | UploadIconSuccessAction
    | UploadIconFailureAction
    | UploadTemplateAction
    | UploadTemplateEndAction;
